import React, { useState } from "react";
import { Form, InputGroup} from "react-bootstrap";

const LogoCustomization = () => {
  const [customLogoURL, setCustomLogoURL] = useState("");
  const [logoHeight, setLogoHeight] = useState("200");
  const [logoWidth, setLogoWidth] = useState("200");

  const handleInputChange = (event, setter) => {
    const newValue = event.target.value;
    setter(newValue);
  };

  const handleLogoUpload = (event) => {
    const file = event.target.files && event.target.files[0];
    if (file) {
      const imageURL = URL.createObjectURL(file);
      setCustomLogoURL(imageURL);
    }
  };



  return (
    <div className="row row-cols-1  row-cols-md-2 p-2">
      <div className="col">
        <div className="border p-3 border-[#e0e6ed] dark:border-[#1b2e4b] dark:bg-[#191e3a]">
          <h3 className="fs-6">Custom Logo URL</h3>
          <div className="custom-file-container">
            <Form.Label htmlFor="customLogoURL" className="cursor-pointer">
              Upload
            </Form.Label>
            <Form.Control
              type="file"
              id="imageUpload"
              name="customLogoURL"
              accept="image/*"
              className="bg-transparent border-none outline-none"
              onChange={handleLogoUpload}
            />
          </div>
          <InputGroup className="mt-3">
            <InputGroup.Text>URL</InputGroup.Text>
            <Form.Control
              name="customLogoURL"
              value={customLogoURL}
              onChange={(e) => handleInputChange(e, setCustomLogoURL)}
              aria-label="Custom Logo URL"
            />
          </InputGroup>
        </div>
      </div>
      <div className="col">
        <div className="border p-3 border-[#e0e6ed] dark:border-[#1b2e4b] dark:bg-[#191e3a]">
          <h3 className="fs-6">Logo Height</h3>
          <Form.Control
            value={logoHeight}
            onChange={(e) => handleInputChange(e, setLogoHeight)}
            type="text"
            name="logoHeight"
            placeholder="Logo Height"
          />
        </div>
      </div>
      <div className="col">
        <div className="border p-3 border-[#e0e6ed] dark:border-[#1b2e4b] dark:bg-[#191e3a]">
          <h3 className="fs-6">Logo Width</h3>
          <Form.Control
            value={logoWidth}
            onChange={(e) => handleInputChange(e, setLogoWidth)}
            type="text"
            name='logoWidth'
            placeholder="Logo Width"
          />
        </div>
      </div>
    </div>
  );
};

export default LogoCustomization;
